import { useContext } from "react";
import { default as _topbar } from "topbar";
import {
  LoadingContext,
  LoadingGetterContext,
  LoadingRouteContext,
} from "./LoadingContext";

export { default as Route } from "./Route";
export { default as Routes } from "./Routes";

export interface TopBarConfig {
  autoRun?: boolean;
  barThickness?: number;
  barColors?: Record<number, string>;
  shadowBlur?: number;
  shadowColor?: string;
  className?: string;
}

export interface TopBar {
  show: () => void;
  hide: () => void;
  config: (conf: TopBarConfig) => void;
}

const topbar: TopBar = _topbar;

const useLoadingContext = () => useContext(LoadingContext);
const useLoadingRouteContext = () => useContext(LoadingRouteContext);
const useLoadingGetterContext = () => useContext(LoadingGetterContext);

export {
  topbar,
  useLoadingContext,
  useLoadingRouteContext,
  useLoadingGetterContext,
  LoadingContext,
  LoadingGetterContext,
};
